import api from '@pray/shared/utils/api';

type DateRangeParams = {
  startDateTime: string;
  endDateTime: string;
};

type LeadCompletenessParams = DateRangeParams & {
  granularity?: 'day' | 'week';
};

export async function getLeadNameCompleteness(params: LeadCompletenessParams) {
  const response = await api.executeGetRequest('/web/studio/name-capture/lead-completeness', params);
  return response.data;
}

export async function getCampaignBreakdown(params: DateRangeParams) {
  const response = await api.executeGetRequest('/web/studio/name-capture/campaign-breakdown', params);
  return response.data;
}

export async function getDeliveryHealth(params: DateRangeParams) {
  const response = await api.executeGetRequest('/web/studio/name-capture/delivery-health', params);
  return response.data;
}

export async function getLeadUserComparison(params: DateRangeParams) {
  const response = await api.executeGetRequest('/web/studio/name-capture/lead-user-comparison', params);
  return response.data;
}
